import { del, get, post, put } from '../utils/httpInterceptor';
import { getCompanyId } from '../utils/companyHelper';
import { buildCrudQueryParams } from './filterQueryBuilder';

class BpmFormService {
  static async getAll(page, size, filters = {}, sortConfig = {}) {
    const companyId = getCompanyId();
    const queryParams = buildCrudQueryParams({
      page,
      size,
      filters,
      sortConfig,
      companyId,
      sortMode: 'split',
    });

    return get(`/bpm-form?${queryParams.toString()}`);
  }

  static async getById(id) {
    return get(`/bpm-form/${id}`);
  }

  static async getByKey(formKey) {
    return get(`/bpm-form/form-key/${encodeURIComponent(formKey)}`);
  }

  static async getAllByKey(formKey) {
    return get(`/bpm-form/all-forms-key/${encodeURIComponent(formKey)}`);
  }

  static async create(payload) {
    const companyId = getCompanyId();
    return post('/bpm-form', { ...payload, companyId });
  }

  static async update(id, payload) {
    const companyId = getCompanyId();
    return put(`/bpm-form/${id}`, { ...payload, companyId });
  }

  static async updateEnabled(id, payload) {
    const companyId = getCompanyId();
    return put(`/bpm-form/${id}`, { ...payload, companyId });
  }

  static async delete(id) {
    return del(`/bpm-form/${id}`);
  }
}

export default BpmFormService;
